var map = {
	"./asbar/asbar-ar.json": [
		6191,
		191
	],
	"./mulkia/mulkia-ar.json": [
		8323,
		323
	],
	"./valueCapital/valueCapital-ar.json": [
		3571,
		571
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(() => {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(() => {
		return __webpack_require__.t(id, 3 | 16);
	});
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = 2936;
module.exports = webpackAsyncContext;